<debug-report-info />

<div class="funds">
  <div>
    <input #newRouteFund type="text" value="{{ routeFund.get() }}">
    <button (click)="setRouteFunds(newRouteFund.value)">Set Fund</button>
  </div>
  <div>
    <input #newJwt type="text" value="{{ jwt }}">
    <button (click)="jwt = newJwt.value">Set JWT</button>
  </div>
</div>

<details>
  <summary>Fondsportrait</summary>
  <rpt-fonds-list-fondsportrait-combo
    force-displayed-component="fondsportrait"
    combo-high-z-index="false"/>
</details>

<hr>

<details>
  <summary>Advanced Fond List</summary>
  <rpt-fonds-list-fondsportrait-combo
    force-displayed-component="fondslist"
    combo-high-z-index="false"
    fondslist-initial-funds-visibility="all"
    fondslist-display-user-fonds-button="true"
    fondslist-control-via-url="true"/>
</details>

<hr>

<details>
  <summary>Fond List</summary>
  <fond-list-widget></fond-list-widget>
</details>

<hr>

<details>
  <summary>Übersicht Gesamtbestand</summary>
  <uebersicht-gesamtbestand></uebersicht-gesamtbestand>
</details>
